<div class="container-fluid">
  <div class="row ">
    <div class="col-md-8">
      <div class="row g-3"> @if (alertInfo.show) {
        <ngb-alert [type]="alertInfo.type"
          (closed)="alertInfo.show = false" class="mb-3">
          <strong>{{ alertInfo.type === 'danger' ? 'Error!' : 'Success!' }}</strong>
          <div [innerHTML]="alertInfo.message"></div>
        </ngb-alert>
      }
      <div class="col-12">
        <div class="card shadow-sm">
          <div class="card-header">
            <h3 class="card-title">{{ regulationId ? 'Update Regulation' : ' Create Regulation' }} </h3>
          </div>
          <div class="card-body">
            <regulations-form [regulation]="regulation" [readonlyRegulationsForm]="readonly"
              (onSavedData)="onRegulationFormSavedData($event)" />
          </div>
        </div>
      </div>
      <div class="col-12">
        <translations-details [readonlyTranslationsDetails]="readonly" [translations]="translations" />
      </div>
      <div class="col-12">
        <regulations-categories [regulationCategory]="category" [readonlyRegulationsCategories]="readonly"
          (onSavedData)="onRegulationCategoriesSavedData($event)" />
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="col-12">
      <div class="col-md-12">
        <regulations-changes-logs [auditLogs]="auditLogs" />
      </div>
    </div>
  </div>
</div>
<!-- <div class="row mt-3" *ngIf="regulationId">
<div class="col-md-12">
  <regulations-changes-logs [changesLog]="changesLog" />
</div>
</div> -->
<div class="row mt-4">
  @if (!readonly) {
    <div class="text-center mt-4">
      <button type="button" class="btn btn-success px-4 py-2" (click)="submitForm()">
        Save
      </button>
    </div>
  }
</div>
</div>